import React, { useState, useEffect } from "react";
import supabase from "../../utils/supabase";

import styles from "./YourGames.module.css";
import bronze from "../../images/bronze_chest.png";
import silver from "../../images/silver_chest.png";
import gold from "../../images/gold_chest.png";

const YourGames = ({ yourScore, updateChest, gameFinishedCounter, name, password }) => {
  const [field1, setField1] = useState(0);
  const [field2, setField2] = useState(0);
  const [field3, setField3] = useState(0);
  const [games, setGames] = useState(0);

  // save game result to supabase when gameFinishedCounter changes
  useEffect(() => {
    if (gameFinishedCounter === 0 || !name) return;

    async function saveGame() {
      const { data: existing, error: selectErr } = await supabase
        .from("Scores")
        .select("*")
        .eq("Name", name);

      if (selectErr) {
        console.error("Error checking Scores:", selectErr.message);
        return;
      }

      const scoreVal = yourScore || 0;
      const passVal = password || "";

      if (!existing || existing.length === 0) {
        // INSERT new record
        let bronzeVal = 0, silverVal = 0, goldVal = 0;
        if (updateChest >= 300 && updateChest <= 399) silverVal = 1;
        else if (updateChest > 400) goldVal = 1;
        else bronzeVal = 1;

        const { error: insertErr } = await supabase.from("Scores").insert([{
          Name: name,
          Pass: passVal,
          Score: scoreVal,
          bronze: bronzeVal,
          silver: silverVal,
          gold: goldVal,
          games: 1,
        }]);

        if (insertErr) console.error("Insert error:", insertErr.message);
        return;
      }

      // UPDATE existing record
      let acc = existing[0];
      let bronzeVal = acc.bronze || 0;
      let silverVal = acc.silver || 0;
      let goldVal = acc.gold || 0;
      let gamesVal = acc.games || 0;

      if (updateChest >= 300 && updateChest <= 399) silverVal += 1;
      else if (updateChest > 400) goldVal += 1;
      else bronzeVal += 1;

      gamesVal += 1;

      let scoreToSave = acc.Score || 0;
      if (scoreVal > scoreToSave) scoreToSave = scoreVal;

      const { error: updateErr } = await supabase
        .from("Scores")
        .update({
          Score: scoreToSave,
          Pass: acc.Pass || passVal,
          bronze: bronzeVal,
          silver: silverVal,
          gold: goldVal,
          games: gamesVal,
        })
        .eq("Name", name);

      if (updateErr) console.error("Update error:", updateErr.message);
    }

    saveGame();
  }, [gameFinishedCounter, yourScore, updateChest, name, password]);


  useEffect(() => {
    async function fetchAccount() {
      if (!name) return;

      const { data, error } = await supabase
        .from("Scores")
        .select("*")
        .eq("Name", name);

      if (error) {
        console.error("Error fetching account:", error.message);
        return;
      }

      if (data && data.length > 0) {
        setField1(data[0].bronze || 0);
        setField2(data[0].silver || 0);
        setField3(data[0].gold || 0);
        setGames(data[0].games || 0);
      }
    }

    fetchAccount();
    const interval = setInterval(fetchAccount, 1000);
    return () => clearInterval(interval);
  }, [name, gameFinishedCounter]);

  return (
    <>
      <div className={styles.reward}>
        <table>
          <tbody>
            <tr>
              <td>
                <img src={bronze} alt="bronze" /> {field1}
              </td>
              <td>
                <img src={silver} alt="silver" /> {field2}
              </td>
              <td>
                <img src={gold} alt="gold" /> {field3}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div className={styles["all-games"]}>total games: {games}</div>
    </>
  );
};

export default YourGames;
